<template>
    <div v-if="this.product && Object.keys(this.sizes).length && this.dates.length" class="table-responsive">
        <table class="table table-stock table-borderless">
            <tbody>
            <tr>
                <td class="sticky">
                    <!-- table-stock-sticky -->
                    <table class="table table-stock-sticky table-regular align-middle">
                        <thead>
                        <tr class="table-regular-h1">
                            <th colspan="2">{{ this.product.sku }}</th>
                        </tr>
                        <tr class="table-regular-h2">
                            <th class="muted">{{ this.product.size_guide ? 'Р-р ' + this.product.size_guide : '' }}</th>
                            <th class="muted">Р-р РФ</th>
                        </tr>
                        </thead>
                        <tbody class="table-group-divider">

                            <template v-for="(size) in this.sizes">
                                <tr>
                                    <td>{{ size.original }}</td>
                                    <td>{{ size.ru }}</td>
                                </tr>
                            </template>

                        <tr>
                            <td colspan="2" class="total">Всего <!--{{ this.item.total ?? 0 }}-->Р</td>
                        </tr>
                        </tbody>
                    </table>
                    <!-- /table-stock-sticky -->
                </td>

                <template v-for="(arrival, date) in this.arrivals">
                    <td class="slidy">
                        <!-- table-stock-slidy -->
                        <table class="table table-stock-slidy table-regular table-borderless align-middle">
                            <thead>
                            <tr class="table-regular-h1">
                                <th colspan="2">
                                    <div class="table-stock-slidy-price item-price item-price-h5">

                                            <strike v-if="arrival.price_old && arrival.price_old !== arrival.price" class="price-old">{{ arrival.price_old_formatted }}</strike>
                                            <strong v-if="arrival.discount" class="price-off">&nbsp;{{ arrival.discount }}%&nbsp;</strong>
                                            <span class="price-current">{{ arrival.price_formatted }}Р</span>

                                    </div>
                                </th>
                            </tr>
                            <tr class="table-regular-h2">
                                <th colspan="2">{{ arrival.date === 'today' ? 'В наличии сегодня' : 'Поступление ' + arrival.date_formatted }}</th>
                            </tr>
                            </thead>
                            <tbody class="table-group-divider">

                                <template v-for="(size) in this.sizes">
                                    <tr>
                                        <td>{{ arrival.sizes[size.original] ?? 0 }} шт.</td>
                                        <td>
                                            <cart-add-button-with-counter
                                                :id="this.id"
                                                :size="size.original"
                                                :date="arrival.date"
                                                :max="arrival.sizes[size.original] ?? 0"
                                                :qty="0"
                                            ></cart-add-button-with-counter>
                                        </td>
                                    </tr>
                                </template>

                            <tr>
                                <td colspan="2" class="total">{{ getArrivalTotal(arrival.date) }}Р</td>
                            </tr>
                            </tbody>
                        </table>
                        <!-- /table-stock-slidy -->
                    </td>
                </template>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: ["id"],

    data: function () {
        return {
            dates: null,
            sizes: null,
            arrivals: null,
            product: null,
        };
    },

    methods: {
        getArrivalTotal(date) {
            let item = this.$store.state.cart.items.find(x => {
                return x.product.id === this.id
            });

            if(!item) {
                return 0;
            }

            return item.arrivals[date]['total_formatted'] ?? 0;
        },

        // getCartQty(date, size) {
        //     console.log(this.id, date, size);
        //     let item = this.$store.state.cart.items.find(x => {
        //         return x.product.id === this.id
        //     });
        //     console.log(item);
        //
        //     if (!item) {
        //         return 0;
        //     }
        //     // console.log(item.arrivals, item.arrivals[date], item.arrivals[date]['cart'], item.arrivals[date]['cart'][size]);
        //
        //     if (typeof item.arrivals[date] !== 'undefined'
        //         && typeof item.arrivals[date]['cart'] !== 'undefined'
        //         && typeof item.arrivals[date]['cart'][size] !== 'undefined'
        //     ) {
        //         console.log(item.arrivals[date]['cart'][size]);
        //         return item.arrivals[date]['cart'][size];
        //     } else {
        //         return 0;
        //     }
        // }
    },

    computed: {
        item() {
            let item = this.$store.state.cart.items.find(x => {
                return x.product.id === this.id
            });

            return item;
        },
    },

    mounted() {
        axios.get('/ajax/product/qty/' + this.id)
            .then(request => {
                this.dates = request.data.data.dates;
                this.sizes = request.data.data.sizes;
                this.arrivals = request.data.data.arrivals;
                this.product = request.data.data.product;
            });
    }
};
</script>
